// extracted by mini-css-extract-plugin
module.exports = {"sub":"PaidSubscriptions_sub__UzEDB","paidSubs":"PaidSubscriptions_paidSubs__1cR-p"};